import React from "react";
import { useFormContext } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { SelectProps } from "./types";
import useOptions from "./hooks";
import styles from "./styles";

const RadioButtons = (props: SelectProps) => {
    const {
        name,
        options,
        label,
        labelCssName,
        cssName,
        fieldOptions
    } = props;

    const { register, formState: { errors } } = useFormContext();

    const [getValue, getLabel] = useOptions(options);

    return (<div className={cssName}>
        <label className={labelCssName}>
            {label}
        </label>

        <ul className="form-radios">
            {options.map((o, index) => (
                <li key={name + "-" + index}>
                    <label className={styles.elements.checkbox.label} htmlFor={`${name}-${index}`}>{getLabel(o)}</label>
                    <input
                        className={styles.elements.checkbox.input}
                        id={`${name}-${index}`}
                        type="radio"
                        value={getValue(o)}
                        {...register(name, fieldOptions)} />
                </li>
            ))}
        </ul>

        <ErrorMessage
            errors={errors}
            name={name}
            render={({ message }) => <p className="error">{message}</p>}
        />
    </div>);
}

export default RadioButtons;